
import Moderator from '@/models/bread/Moderator/seriesSponsor'


export default {
    key: 'SeriesSponsor',
    name: {
        singular: 'Sponsor',
        plural: 'Sponsors',
    },
    parents: [
        'Series',
    ],
    Admin: false,
    Moderator: Moderator,
    Teacher: false,
}